import { toast } from "react-toastify";
import { useUserData } from "../../../hooks/useUserData";
import { swingLibraryService } from "../../../services/swingLibrary";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useInvalidate } from "../../../hooks/useInvalidate";

const initialIndicators = [
  {
    id: "CHSTTRNTOP",
    name: "Chest Turn at TOP",
    positionOrPhase: "TOP",
    unit: "Degrees",
  },
  {
    id: "XFCTRMAXNRTOP",
    name: "X-Factor Max Near TOP",
    positionOrPhase: "Backswing",
    unit: "Degrees",
  },
  {
    id: "CHSTSBNDFTHRUMAX",
    name: "Chest Side Bend FollowThru Max",
    positionOrPhase: "FollowThru",
    unit: "Degrees",
  },
];

export function useSwingLibrarySettings() {
  const { userData } = useUserData();

  return useQuery({
    enabled: !!userData?.uid,
    queryKey: ["getSwingLibrarySettings_key", userData?.uid],
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      try {
        const res = await swingLibraryService.getSwingLibrarySettings({
          userId: userData?.uid,
        });

        return {
          ...res,
          savedIndicators: res?.savedIndicators ?? initialIndicators,
          tourAveragesToggle: !!res?.tourAveragesToggle,
        };
      } catch (error) {
        const msg = error?.message || "Failed to load swing library settings";
        toast.error(msg);
        return null;
      }
    },
  });
}

export function useUpdateSwingLibrarySettings() {
  const { userData } = useUserData();
  const invalidate = useInvalidate();

  return useMutation({
    mutationFn: async (dataPatch) => {
      try {
        if (!userData?.uid) {
          throw new Error("User ID is required");
        }
        return await swingLibraryService.updateSwingLibrarySettings({
          data: dataPatch,
          userId: userData?.uid,
        });
      } catch (error) {
        const msg = error?.message || "Failed to update settings";
        toast.error(msg);
        throw new Error(msg);
      }
    },
    onSuccess: async () => {
      await invalidate(["getSwingLibrarySettings_key"]);
    },
  });
}
